import { gql } from "@apollo/client";
import { print } from "@apollo/client/utilities";
import { PaginationInfo } from "components/CRPComponents/Tables/GenericTable/types";

export const GET_ALL_QUERY = print(gql`
  query Partners($page: Int, $perPage: Int, $search: String, $active: Boolean) {
    Partners(page: $page, perPage: $perPage, search: $search, active: $active) {
      items {
        id
        name
        visibleName
        active
        cnpj
      }
      paginationInfo {
        page
        perPage
        hasMore
        totalPages
        totalData
        nextPage {
          page
          perPage
        }
      }
    }
  }
`);

export interface GetAllItem {
  id: number;
  name: string;
  value: string;
}

export interface GetAllGql {
  Partners: {
    items: GetAllItem[];
    paginationInfo: PaginationInfo;
  };
}
